import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export function generatePDF(summary, results, filename) {
  const doc = new jsPDF();

  // Header
  doc.setFillColor(26, 35, 126);
  doc.rect(0, 0, 210, 30, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('5G Delay Intelligence Report', 14, 18);

  // Date
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 26);

  // File info
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.text(`Source File: ${filename || 'uploaded.csv'}`, 14, 42);

  // Summary stats table
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(26, 35, 126);
  doc.text('Summary Statistics', 14, 55);

  autoTable(doc, {
    startY: 60,
    head: [['Metric', 'Value']],
    body: [
      ['Total Predictions', summary.total_predictions],
      ['Average Predicted Delay', `${summary.avg_predicted_delay} ms`],
      ['Peak Predicted Delay', `${summary.peak_predicted_delay} ms`],
      ['Minimum Predicted Delay', `${summary.min_predicted_delay} ms`],
      ['Mean Absolute Error (MAE)', `${summary.mae} ms`],
      ['Root Mean Square Error (RMSE)', `${summary.rmse} ms`],
    ],
    headStyles: { fillColor: [26, 35, 126] },
    alternateRowStyles: { fillColor: [232, 234, 246] },
  });

  // Results table (first 100)
  const startY = doc.lastAutoTable.finalY + 14;
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(26, 35, 126);
  doc.text('Prediction Results (first 100)', 14, startY);

  autoTable(doc, {
    startY: startY + 5,
    head: [['SN', 'Actual (ms)', 'Predicted (ms)', 'Difference (ms)']],
    body: results.slice(0, 100).map(r => [r.sn, r.actual, r.predicted, r.difference]),
    headStyles: { fillColor: [26, 35, 126] },
    alternateRowStyles: { fillColor: [232, 234, 246] },
  });

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.text('5G Network Delay Intelligence Platform | Powered by Hybrid LSTM', 14, 290);
    doc.text(`Page ${i} of ${pageCount}`, 185, 290);
  }

  doc.save(`5G_Delay_Report_${Date.now()}.pdf`);
}
